import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { AlertCircle } from 'lucide-react';
export function StorySection() {
  return <section className="py-6 md:py-24 px-4 bg-white" data-id="element-178">
      <div className="max-w-3xl mx-auto" data-id="element-179">
        <FadeIn data-id="element-180">
          <img src="https://cdn.magicpatterns.com/uploads/9CCZUPdQ5wA7Lm2Pp5TP8K/ebook_chau_vaoe_.webp" alt="Tienda de vape - líquidos y sales de nicotina" className="w-full rounded-xl mb-3 md:mb-6" data-id="element-181" />
          <h2 className="font-display font-black text-3xl md:text-5xl text-gray-900 mb-3 md:mb-8" data-id="element-182">
            El problema no es la nicotina, es el{' '}
            <span className="text-celeste" data-id="element-183">
              sistema que tu cerebro aprendió.
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-3 md:space-y-8 text-lg md:text-xl text-gray-700" data-id="element-184">
          <FadeIn delay={0.1} data-id="element-185">
            <p data-id="element-186">
              Vapeás cuando estás estresado. Vapeás cuando estás aburrido.
              Vapeás cuando salís. Ya no es una elección, es un reflejo
              automático.
            </p>
          </FadeIn>

          <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 my-4 md:my-8" data-id="element-187">
            {['Ansiedad constante', 'Gasto de guita mensual que no ves', 'Tos, falta de aire y cansancio', 'Dependencia 24/7'].map((item, idx) => <StaggerItem key={idx} className="bg-gray-50 border border-gray-200 rounded-lg p-4 flex items-center space-x-3" data-id="element-188">
                <AlertCircle className="text-red-500 shrink-0" size={20} data-id="element-189" />
                <span className="font-medium text-gray-800 text-base md:text-lg" data-id="element-190">
                  {item}
                </span>
              </StaggerItem>)}
          </StaggerContainer>
        </div>
      </div>
    </section>;
}